<template>
    <div class="space-y-6">
        <!-- 网盘音乐管理 -->
        <div class="card bg-base-100 shadow-lg border border-base-200">
            <div class="card-body">
                <h2 class="card-title text-lg font-semibold mb-4 flex items-center">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"></path>
                    </svg>
                    {{ $tt('网盘音乐管理') }}
                </h2>
                
                <!-- 挂载路径信息 -->
                <div class="bg-base-200/50 rounded-lg p-4 mb-6">
                    <div class="flex items-center justify-between mb-2">
                        <span class="text-sm font-medium text-base-content/70">{{ $tt('挂载路径') }}</span>
                        <div class="badge badge-outline cursor-pointer hover:bg-base-200 transition-colors"
                            @click="$emit('redirect-edit', '/app/webdav/')">
                            /app/webdav
                        </div>
                    </div>
                    <div class="alert py-2">
                        <svg class="stroke-current shrink-0 w-4 h-4" fill="none" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                        <span class="text-sm">{{ $tt('本地挂载模式需要挂载映射到这个目录，直连模式不需要挂载可直接在这个目录查看。') }}</span>
                    </div>
                </div>

                <!-- 工作模式选择 -->
                <div class="mb-6">
                    <h3 class="font-medium mb-3 flex items-center">
                        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4"></path>
                        </svg>
                        {{ $tt('工作模式') }}
                    </h3>
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div class="form-control bg-base-200/30 rounded-lg p-4 border-2 transition-colors"
                            :class="formData.alist_mode === 'direct' ? 'border-primary bg-primary/5' : 'border-transparent'">
                            <label class="label cursor-pointer justify-start gap-3">
                                <input type="radio" name="radio-10" class="radio radio-primary" value="direct"
                                    v-model="formData.alist_mode" @change="$emit('update-sys', 'alist_mode')" />
                                <div>
                                    <span class="label-text font-medium">{{ $tt('直连模式') }}</span>
                                    <div class="text-xs text-base-content/60 mt-1">{{ $tt('直接连接OpenList服务') }}</div>
                                </div>
                            </label>
                        </div>
                        <div class="form-control bg-base-200/30 rounded-lg p-4 border-2 transition-colors"
                            :class="formData.alist_mode === 'local' ? 'border-accent bg-accent/5' : 'border-transparent'">
                            <label class="label cursor-pointer justify-start gap-3">
                                <input type="radio" name="radio-10" class="radio radio-accent" value="local"
                                    v-model="formData.alist_mode" @change="$emit('update-sys', 'alist_mode')" />
                                <div>
                                    <span class="label-text font-medium">{{ $tt('本地挂载') }}</span>
                                    <div class="text-xs text-base-content/60 mt-1">{{ $tt('通过本地挂载访问') }}</div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>

                <!-- 直连模式配置 -->
                <div v-if="formData.alist_mode === 'direct'" class="space-y-6">
                    <!-- OpenList 服务配置 -->
                    <div class="bg-base-200/50 rounded-lg p-6">
                        <h4 class="font-medium mb-4 flex items-center">
                            <svg class="w-4 h-4 mr-2 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01"></path>
                            </svg>
                            {{ $tt('OpenList 服务配置') }}
                        </h4>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div class="form-control">
                                <label class="label">
                                    <span class="label-text font-medium">OpenList URL</span>
                                </label>
                                <input type="text" :placeholder="$tt('请输入 OpenList 的 URL')"
                                    @change="$emit('update-sys', 'alist_url')" v-model="formData.alist_url"
                                    class="input input-bordered focus:input-primary" />
                                <label class="label">
                                    <span class="label-text-alt text-base-content/70">{{ $tt('确保该系统可以访问到 OpenList 地址，例如：http://192.168.0.115:5244') }}</span>
                                </label>
                            </div>
                            <div class="form-control">
                                <label class="label">
                                    <span class="label-text font-medium">{{ $tt('根目录') }}</span>
                                </label>
                                <input type="text" :placeholder="$tt('请输入 OpenList 的根目录')"
                                    @change="$emit('update-sys', 'alist_root_path')" v-model="formData.alist_root_path"
                                    class="input input-bordered focus:input-primary" />
                                <label class="label">
                                    <span class="label-text-alt text-base-content/70">{{ $tt('OpenList 根目录地址，例如：/aliyun/音乐') }}</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- 账号认证 -->
                    <div class="bg-base-200/50 rounded-lg p-6">
                        <h4 class="font-medium mb-4 flex items-center">
                            <svg class="w-4 h-4 mr-2 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                            </svg>
                            {{ $tt('账号认证') }}
                        </h4>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div class="form-control">
                                <label class="label">
                                    <span class="label-text font-medium">{{ $tt('用户名') }}</span>
                                </label>
                                <input type="text" :placeholder="$tt('请输入账号')"
                                    class="input input-bordered focus:input-secondary"
                                    v-model="formData.alist_username" @change="$emit('update-sys', 'alist_username')" />
                                <label class="label">
                                    <span class="label-text-alt text-base-content/70">{{ $tt('OpenList 的用户名') }}</span>
                                </label>
                            </div>
                            <div class="form-control">
                                <label class="label">
                                    <span class="label-text font-medium">{{ $tt('密码') }}</span>
                                </label>
                                <input type="password" :placeholder="$tt('请输入密码')"
                                    class="input input-bordered focus:input-secondary"
                                    v-model="formData.alist_password" @change="$emit('update-sys', 'alist_password')" />
                                <label class="label">
                                    <span class="label-text-alt text-base-content/70">{{ $tt('OpenList 账号密码') }}</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- 高级设置 -->
                    <div class="bg-base-200/50 rounded-lg p-6">
                        <h4 class="font-medium mb-4 flex items-center">
                            <svg class="w-4 h-4 mr-2 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                            </svg>
                            {{ $tt('高级设置') }}
                        </h4>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 items-end">
                            <div class="form-control">
                                <label class="label">
                                    <span class="label-text font-medium">{{ $tt('显示条数') }}</span>
                                </label>
                                <input type="number" min="1" :placeholder="$tt('请输入显示的条数')" 
                                    @change="$emit('update-sys', 'alist_page_size')"
                                    v-model="formData.alist_page_size"
                                    class="input input-bordered focus:input-accent" />
                                <label class="label">
                                    <span class="label-text-alt text-base-content/70">{{ $tt('限制每个目录显示的条数') }}</span>
                                </label>
                            </div>
                            <div class="form-control">
                                <button class="btn btn-outline btn-warning gap-2" @click="handleTask2('clear_webdav_cache')">
                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                                    </svg>
                                    {{ $tt('清除缓存') }}
                                </button>
                                <label class="label">
                                    <span class="label-text-alt text-base-content/70">{{ $tt('清除缓存的元数据文件') }}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 本地挂载配置 -->
                <div v-else class="bg-base-200/50 rounded-lg p-6">
                    <h4 class="font-medium mb-4 flex items-center">
                        <svg class="w-4 h-4 mr-2 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01"></path>
                        </svg>
                        {{ $tt('OpenList 服务配置') }}
                    </h4>
                    <div class="form-control max-w-md">
                        <label class="label">
                            <span class="label-text font-medium">OpenList URL</span>
                        </label>
                        <input type="text" :placeholder="$tt('请输入OpenList的URL地址')"
                            @change="$emit('update-sys', 'alist_url')" v-model="formData.alist_url"
                            class="input input-bordered focus:input-primary" />
                        <label class="label">
                            <span class="label-text-alt text-base-content/70">{{ $tt('确保该系统可以访问到 OpenList 地址，例如：http://192.168.0.115:5244') }}</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WebdavMusic',
    props: {
        formData: {
            type: Object,
            default: () => ({})
        }
    },
    emits: ['update-sys', 'redirect-edit'],
    methods: {
        handleTask2(taskType) {
            this.$api.Task.debugTask2({ 'mode': taskType }).then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: this.$tt('修改成功！'),
                        type: 'success',
                        time: 2000,
                    })
                }
            })
        }
    }
}
</script> 
